import type { DataLoadMapType } from '../reducers';

export type AuxiliaryDataStateType = 'resource';

export type DataStateType = keyof DataLoadMapType | AuxiliaryDataStateType;

export interface GenericState<IdType> {
  _tag: string;

  type: DataStateType;
  id: IdType;
}

export interface IdleState<IdType> extends GenericState<IdType> {
  _tag: 'idle';
}
export interface LoadingState<IdType> extends GenericState<IdType> {
  _tag: 'loading';
}
export interface DataState<IdType, Type> extends GenericState<IdType> {
  _tag: 'data';
  data: Type;
}
export interface ErrorState<IdType> extends GenericState<IdType> {
  _tag: 'error';
  message: string;
}

export type State<IdType, Type> =
  | IdleState<IdType>
  | LoadingState<IdType>
  | DataState<IdType, Type>
  | ErrorState<IdType>;

export function isIdleState<IdType, StateType>(
  obj: State<IdType, StateType>
): obj is IdleState<IdType> {
  return obj._tag === 'idle';
}
export function isLoadingState<IdType, StateType>(
  obj: State<IdType, StateType>
): obj is LoadingState<IdType> {
  return obj._tag === 'loading';
}
export function isDataState<IdType, StateType>(
  obj: State<IdType, StateType>
): obj is DataState<IdType, StateType> {
  return obj._tag === 'data';
}
export function isErrorState<IdType, StateType>(
  obj: State<IdType, StateType>
): obj is ErrorState<IdType> {
  return obj._tag === 'error';
}

export function isUnknownIdleState(obj: any): obj is IdleState<unknown> {
  return obj._tag === 'idle';
}
export function isUnknownLoadingState(obj: any): obj is LoadingState<unknown> {
  return obj._tag === 'loading';
}
export function isUnknownDataState(
  obj: any
): obj is DataState<unknown, unknown> {
  return obj._tag === 'data';
}
export function isUnknownErrorState(obj: any): obj is ErrorState<unknown> {
  return obj._tag === 'error';
}
